export const enum OnboardingStatusEnum {
    DRAFT = 1,
    ACTIVE
}